module.exports = __webpack_public_path__ + "img/image_5.f668ef6d.png";